// src/Public/maps-data.js
// Map / contact section content. he mirrors en for now (pending translation).
const MAPS_CONTENT = {
    // Two-line heading with an accent middle phrase: "{pre} {accent} {post}".
    heading: { pre: "Let's Bring Your", accent: 'Outdoor Space', post: 'to Life.' },
    subtitle: 'Our team is here to help. Get in touch, schedule a call, or visit one of our locations across the country.',

    // Left card, response time + quick actions.
    responseEyebrow: 'Response Time',
    responseValue: 'Usually within 1 business day',
    actions: [
        { key: 'call', icon: 'phone', title: 'Call Now', subtitle: 'Speak with our team' },
        { key: 'message', icon: 'mail', title: 'Message Us', subtitle: 'Send us a quick message' },
        { key: 'schedule', icon: 'calendar', title: 'Schedule a Meeting', subtitle: 'Find a time that works for you' },
    ],

    // Business hours (grouped rows). Client can override per deployment.
    hoursTitle: 'Business Hours',
    hoursRows: [
        { label: 'Mon-Fri', value: '8:00 AM - 5:00 PM (EST)' },
        { label: 'Sat-Sun', value: 'Closed' },
    ],

    // Map overlays.
    dealerPill: 'Find a Dealer Near You',
    legendTitle: 'Authorized Dealers',
    legendSubtitle: 'Across North America',
    openMapsLabel: 'View Coverage Area',

    // Default embedded map (no API key), North America. Client overrides via the
    // "Business Maps" link in system_data.
    mapEmbedUrl: 'https://maps.google.com/maps?q=United%20States&z=4&output=embed',

    // Decorative dealer pins (percent coords over the map). Real coverage is data-driven.
    zones: [
        { id: 'z1', label: 'Pacific NW', x: 20, y: 30, info: 'Authorized dealer', icon: 'install' },
        { id: 'z2', label: 'Northern CA', x: 15, y: 48, info: 'Authorized dealer', icon: 'install' },
        { id: 'z3', label: 'Southern CA', x: 18, y: 58, info: 'Authorized dealer', icon: 'install' },
        { id: 'z4', label: 'Southwest', x: 30, y: 62, info: 'Authorized dealer', icon: 'install' },
        { id: 'z5', label: 'Mountain', x: 34, y: 42, info: 'Authorized dealer', icon: 'install' },
        { id: 'z6', label: 'Midwest', x: 55, y: 40, info: 'Authorized dealer', icon: 'install' },
        { id: 'z7', label: 'Texas', x: 48, y: 66, info: 'Authorized dealer', icon: 'install' },
        { id: 'z8', label: 'Southeast', x: 68, y: 62, info: 'Authorized dealer', icon: 'install' },
        { id: 'z9', label: 'Florida', x: 72, y: 74, info: 'Authorized dealer', icon: 'install' },
        { id: 'z10', label: 'Mid-Atlantic', x: 74, y: 48, info: 'Authorized dealer', icon: 'install' },
        { id: 'z11', label: 'Northeast', x: 80, y: 38, info: 'Authorized dealer', icon: 'install' },
    ],
};

const MapsData = {
    en: MAPS_CONTENT,
    he: MAPS_CONTENT,
};

export function getMapsData(language) {
    return MapsData[language === 'he' ? 'he' : 'en'];
}

export default MapsData;
